import React from 'react';
import { Popover } from 'antd';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { renderRecordValue } from '../../../utils';
import styles from './index.module.css';
import { FrequentFlyerIcon } from '../../../assets';

export const FrequentFlyerPatientIcon = ({
  tooltip = 'Frequent Rider', // Default tooltip content
  width = 20, // Default width
  height = 18, // Default height
  fill = '#E1F4D3', // Default fill color
  text = '', // Default text for renderRecordValue
  showText = false, // Conditional rendering for renderRecordValue
}) => {

  const renderContent = () => (
    <div className={showText ? styles.leg : undefined}>
      <FrequentFlyerIcon fill={fill} width={width} height={height} />
      {showText && <span className={styles.ml_5}>{renderRecordValue(text)}</span>}
    </div>
  );

  return tooltip && tooltip.trim() ? (
    <Popover
      content={tooltip}
      trigger="hover"
      overlayClassName={classNames(styles.overlay)}
      getPopupContainer={(trigger) => document.body}
    >
      {renderContent()}
    </Popover>
  ) : (
    renderContent()
  );

};

FrequentFlyerPatientIcon.propTypes = {
  tooltip: PropTypes.string, // Tooltip content
  width: PropTypes.number, // Icon width
  height: PropTypes.number, // Icon height
  fill: PropTypes.string, // Icon fill color
  text: PropTypes.string, // Text for renderRecordValue
  showText: PropTypes.bool, // Whether to show renderRecordValue
};
